import { render, staticRenderFns } from "./floating-side-wrapper.vue?vue&type=template&id=be9b4700&scoped=true&"
import script from "./floating-side-wrapper.vue?vue&type=script&lang=js&"
export * from "./floating-side-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./floating-side-wrapper.vue?vue&type=style&index=0&id=be9b4700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9b4700",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be9b4700')) {
      api.createRecord('be9b4700', component.options)
    } else {
      api.reload('be9b4700', component.options)
    }
    module.hot.accept("./floating-side-wrapper.vue?vue&type=template&id=be9b4700&scoped=true&", function () {
      api.rerender('be9b4700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wrappers/floating-side-wrapper.vue"
export default component.exports